module.exports = ":host{z-index:100000}\n"